'use client';

import React, { useState } from 'react';
import { copyToClipboard } from '@/services/util';
import Image from 'next/image';
import shareIcon from '../../../../public/assets/share-icon.svg';

interface ShareFormProps {
  formData: string;
  onShared?: () => void;
}

const ShareForm: React.FC<ShareFormProps> = ({ formData, onShared }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const handleClick = () => {
    copyToClipboard(formData);
    onShared?.();
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1000);
  };
  return (
    <div className="relative inline-block">
      <div
        className="flex items-center gap-1 text-[#012A38] font-inter text-[12px] font-normal cursor-pointer"
        onClick={handleClick}
      >
        <Image src={shareIcon} alt="share_icon" />
        Share Form
      </div>

      {showTooltip && (
        <div
          className={`absolute left-1/2 bottom-full mb-2 -translate-x-1/2 whitespace-nowrap bg-gray-600 text-white text-xs px-2 py-1 rounded-md shadow-md transition-all duration-200 ease-out ${
            showTooltip
              ? 'opacity-100 translate-y-0 z-50'
              : 'opacity-0 translate-y-2'
          }`}
        >
          Copied!
        </div>
      )}
    </div>
  );
};

export default ShareForm;
